'use client';

import { type FC, memo, useMemo } from 'react';
import { NativeSlider } from '@/components/NativeSlider';
import { SliderArrow } from '@/components/NativeSlider/helpers';
import { useGamesSliderData } from '../../hooks/useGamesSliderData';
import {
  type LobbyGamesSlideProps,
  Slide,
} from '../LobbyGamesSlider/components/Slide/Slide';
import { SliderHeader } from '../SliderHeader';
import { ViewAllButton } from '../ViewAllButton';
import { ScGamesSliderContainer } from './styled';
import type { IGamesSliderProps } from './types';

export const GamesSlider: FC<IGamesSliderProps> = memo(
  ({ categoryId, title, icon, config, dataTestId }) => {
    const { slides, pagination, deviceConfig, isEmpty } = useGamesSliderData(
      categoryId,
      config
    );

    const arrows = useMemo(
      () => ({
        type: SliderArrow.OUTSIDE,
        componentLeft: <SliderHeader icon={icon} title={title} />,
        componentRight: (
          <ViewAllButton
            categoryId={categoryId}
            totalCount={pagination.totalCount}
          />
        ),
      }),
      [categoryId, icon, pagination.totalCount, title]
    );

    if (isEmpty) return null;

    return (
      <ScGamesSliderContainer>
        <NativeSlider<LobbyGamesSlideProps>
          arrows={arrows}
          dataTestId={dataTestId}
          slide={Slide}
          slides={slides}
          slidesPerView={deviceConfig.slidesPerView}
        />
      </ScGamesSliderContainer>
    );
  }
);
